import React from 'react'
import styles from './Overlay.module.css'

const Overlay = ({ customStyle }) => {
  return <div className={styles.Overlay} style={customStyle}></div>
}

export default Overlay
